import React from 'react';
import {
  Box,
  Button, Card, CardActions, CardContent,
  Divider,
  IconButton,
  LinearProgress,
  Modal, Typography
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { makeStyles } from '@material-ui/styles';
import { useState } from 'react';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import axios from 'src/utils/axios';
import { base64Reader, saveFotograf } from 'src/utils/storage/StrPhoto';
import logger from 'src/utils/logger';

// FFmpeg importlarını ve init kısmını siliyoruz çünkü hata veren o.
const Compress = require('compress.js').default;
const compress = new Compress();

const useStyles = makeStyles(() => ({
  // ... mevcut stillerin (modal, root, header vb.) aynen kalıyor
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  root: { width: 600, maxWidth: '95%', borderRadius: 12, outline: 'none', backgroundColor: '#fdfdfd' },
  header: { padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#424242', color: '#FF9800' },
  content: { padding: 24, minHeight: 250 },
  actions: { padding: 16, justifyContent: 'flex-end', backgroundColor: '#f5f5f5' },
  progressContainer: { width: '100%', marginTop: 20, textAlign: 'center' },
}));

const compressVideo = async (file, onProgress) => {
  return new Promise((resolve) => {
    const video = document.createElement("video");
    video.preload = "metadata";
    video.src = URL.createObjectURL(file);
    video.muted = true;
    video.onloadedmetadata = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const maxWidth = 1280;
      const scale = Math.min(1, maxWidth / video.videoWidth);

      canvas.width = video.videoWidth * scale;
      canvas.height = video.videoHeight * scale;

      const stream = canvas.captureStream();
      const audioTrack = video.captureStream().getAudioTracks()[0];
      if (audioTrack) stream.addTrack(audioTrack);

      const recorder = new MediaRecorder(stream, {
        mimeType: "video/webm; codecs=vp9",
        videoBitsPerSecond: 700000,
      });

      let chunks = [];
      recorder.ondataavailable = (e) => chunks.push(e.data);

      const finish = () => {
        recorder.stop();
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: "video/webm" });
        resolve(blob);
      };

      recorder.start(200);

      const duration = video.duration;
      const startTime = Date.now();

      // Güvenlik Timer (max 120% süre)
      const timeout = duration * 1200; // duration * 1000 * 1.2

      const draw = () => {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        if (typeof onProgress === "function") {
          const percent = Math.min(
            100,
            Math.round((video.currentTime / duration) * 100)
          );
          onProgress(percent);
        }

        if (video.ended) {
          finish();
          return;
        }

        // Güvenlik: son saniyede kalıyorsa zorla bitir
        if (Date.now() - startTime > timeout) {
          finish();
          return;
        }

        requestAnimationFrame(draw);
      };

      video.onended = () => {
        finish();
      };

      video.play().then(() => draw());
    };
  });
};



function FilePopup({ open, onClose, FisNo, DosyaTipi, DosyaTipiText, className, issondaj = 0 }) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [statusText, setStatusText] = useState("");

  if (!open) return null;

  // Dropzone içeriği için ikonlu bir bileşen oluşturuyoruz
  const DropzoneContent = (
    <div style={{ textAlign: 'center' }}>
      <CloudUploadIcon style={{ fontSize: 48, color: '#FF9800', marginBottom: 8 }} />
      <Typography style={{ color: '#FF9800', fontWeight: 'bold' }}>
        Dosyaları buraya bırakın veya tıklayın
      </Typography>
      <Typography variant="caption" color="textSecondary">
        (Görüntü ve videolar otomatik optimize edilir)
      </Typography>
    </div>
  );

  const handleSubmit = async (files) => {
    setLoading(true);
    const MAX_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

    for (let i = 0; i < files.length; i++) {
      const { file, meta } = files[i];
      let finalData = "";

      try {
        if (meta.type.startsWith('image/')) {
          setStatusText(`${meta.name} optimize ediliyor...`);
          if (meta.size > MAX_SIZE_BYTES) {
            try {
              // 'resized' yerine 'resizedResults' kullanarak tanım hatasını çözüy oruz
              const resizedResults = await compress.compress([file], {
                size: 0.2, quality: 0.75, maxWidth: 1920, maxHeight: 1920, resize: true
              });
              finalData = resizedResults?.[0]?.data;
            } catch (compressError) {
              // compress.js EXIF okuma sırasında "Invalid time value" hatası verebilir
              logger.warn("FilePopup Compress error (possibly EXIF date issue):", compressError.message);
              finalData = await base64Reader(file);
            }
          } else {
            finalData = await base64Reader(file);
          }
        }
        else if (meta.type.startsWith('video/')) {
          setStatusText(`${meta.name} video sıkıştırılıyor…`);
          let compressedBlob;
          if (meta.size > MAX_SIZE_BYTES) {
            compressedBlob = await compressVideo(file, (percent) => {
              setProgress(percent);
            });
          } else {
            compressedBlob = file;
          }
          setProgress(0);
          finalData = await base64Reader(compressedBlob);
        }
        else {
          // Diğer dosya türleri (PDF vb.)
          if (meta.size > MAX_SIZE_BYTES) {
            alert(`"${meta.name}" 5MB limitini aşıyor.`);
            continue;
          }
          finalData = await base64Reader(file);
        }

        // --- YÜKLEME AŞAMASI ---
        setStatusText(`${meta.name} sunucuya aktarılıyor...`);
        setProgress(0);

        if (!window.navigator.onLine) {
          saveFotograf(FisNo, finalData, DosyaTipi, meta.name, meta.type);
        } else {
          await axios.post('/FileImportExport/ArtemisFileUpload', {
            Title: `${DosyaTipiText} - ${meta.name}`,
            MIMEType: meta.type,
            ServiscePaperId: FisNo?.toString(),
            DosyaTipi: DosyaTipi?.toString(),
            FileData: finalData,
            issondaj: issondaj?.toString()
          }, {
            onUploadProgress: (p) => {
              const percentCompleted = Math.round((p.loaded * 100) / p.total);
              setProgress(percentCompleted);
            }
          }).catch(uploadError => {
            // Hata detaylarını logla
            logger.error("FilePopup Upload Hatası:", {
              message: uploadError.message,
              status: uploadError.response?.status,
              file: meta.name,
              size: meta.size
            });

            // 502, 413 veya diğer hatalar için offline kaydet
            if (uploadError.response?.status === 502 || uploadError.response?.status === 413) {
              logger.warn(`Dosya çok büyük, offline kaydediliyor: ${meta.name}`);
              saveFotograf(FisNo, finalData, DosyaTipi, meta.name, meta.type);
            } else {
              throw uploadError; // Diğer hataları yukarıya fırlat
            }
          });
        }
      } catch (err) {
        logger.error("FilePopup Genel Hata:", err);
        
        if (err.response && (err.response.status === 502 || err.response.status === 413)) {
          alert("Dosya boyutu çok büyük. Offline kaydedildi.");
        } else {
          alert("İşlem sırasında bir hata oluştu.");
        }
        setLoading(false);
        return;
      }
    }

    setLoading(false);
    onClose();
  };
  return (
    <Modal open={open} onClose={onClose} className={classes.modal}>
      <Card className={className ? `${classes.root} ${className}` : classes.root}>
        {/* Header Section */}
        <div className={classes.header}>
          <Typography variant="h6" style={{ fontWeight: 600, color: '#FF9800' }}>
            <CloudUploadIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#FF9800' }} />
            Dosya Yükleme Merkezi
          </Typography>
          <IconButton size="small" onClick={onClose} style={{ color: '#fff' }}>
            <CloseIcon />
          </IconButton>
        </div>

        <CardContent className={classes.content}>
          {!loading ? (
            <Dropzone
              onSubmit={handleSubmit}
              /* İkonlu içeriği burada veriyoruz */
              inputContent={DropzoneContent}
              submitButtonContent="Yüklemeyi Başlat"
              accept="*"
              maxFiles={5}
              styles={{
                dropzone: {
                  minHeight: 250, // İkon geldiği için biraz yükselttik
                  border: '2px dashed #FF9800',
                  borderRadius: 12,
                  backgroundColor: '#fff9f0', // Hafif bir arka plan rengi
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                inputLabel: {
                  padding: '20px',
                  cursor: 'pointer'
                },
                submitButton: {
                  backgroundColor: '#FF9800',
                  color: '#ffffff',
                  borderRadius: 8,
                  padding: '10px 24px',
                  marginTop: 10,
                  textTransform: 'none',
                  fontWeight: 'bold'
                },
                inputLabelWithFiles: {
                  color: '#FF9800',
                  marginBottom: 10
                }
              }}
            />
          ) : (
            <div className={classes.progressContainer}>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                {statusText}
              </Typography>
              <Box display="flex" alignItems="center" mt={2}>
                <Box width="100%" mr={1}>
                  <LinearProgress variant="determinate" value={progress} color="primary" style={{ height: 10, borderRadius: 5 }} />
                </Box>
                <Box minWidth={35}>
                  <Typography variant="body2" color="textSecondary">{`${progress}%`}</Typography>
                </Box>
              </Box>
              <Typography variant="caption" display="block" style={{ marginTop: 20 }}>
                Lütfen pencereyi kapatmayın, işlem devam ediyor...
              </Typography>
            </div>
          )}
        </CardContent>

        <Divider />

        <CardActions className={classes.actions}>
          <Button
            onClick={onClose}
            variant="contained"
            disabled={loading}
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}
          > Kapat
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

export default FilePopup;